import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TrackList } from "@/components/tracks/TrackList";
import { musicService } from "@/services/musicService";
import type { Track } from "@/types/types";

export function ArtistLikedPage() {
  const { id = "" } = useParams();
  const [tracks, setTracks] = useState<Track[]>([]);
  useEffect(() => {
    musicService.likedTracks().then((p) => setTracks(p.items.filter((t) => t.artist.id === id))).catch(console.error);
  }, [id]);
  return (
    <div>
      <h1>Titres likés de l'artiste</h1>
      <TrackList tracks={tracks} />
    </div>
  );
}
